"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartParams = void 0;
var is_plain_obj_1 = __importDefault(require("is-plain-obj"));
var base62str_1 = __importDefault(require("base62str"));
var base62 = base62str_1.default.createInstance();
var StartParams = /** @class */ (function () {
    /**
     * 创建一个 StartParams 对象。
     *
     * @param params 参数对象，可以是字符串、纯对象或 StartParams 实例。接受数组形式，传入数组会合并所有项目。
     */
    function StartParams(params) {
        if (typeof params === 'string') {
            return StartParams.parse(params);
        }
        if ((0, is_plain_obj_1.default)(params)) {
            Object.assign(this, params);
        }
        else if (params instanceof StartParams) {
            Object.assign(this, JSON.parse(JSON.stringify(params)));
        }
        else if (Array.isArray(params)) {
            for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
                var param = params_1[_i];
                if (typeof param === 'string') {
                    Object.assign(this, StartParams.parse(param));
                }
                else if (param != null) {
                    Object.assign(this, JSON.parse(JSON.stringify(param)));
                }
            }
        }
        // 复制旧值
        if (this.fileGuid == null && this.guid != null) {
            this.fileGuid = this.guid;
        }
        // 如果值不一致，则用 fileGuid 覆盖 guid，避免出问题
        if (this.guid != null && this.fileGuid !== this.guid) {
            this.guid = this.fileGuid;
        }
    }
    /**
     * 将字符串解析为 StartParams 对象。
     *
     * @param paramStr 待解析的字符串。
     */
    StartParams.parse = function (paramStr) {
        return new StartParams(JSON.parse(base62.decodeStr(paramStr)));
    };
    /**
     * 将 StartParams 对象转换为字符串。
     */
    StartParams.prototype.toString = function () {
        return base62.encodeStr(JSON.stringify(this));
    };
    return StartParams;
}());
exports.StartParams = StartParams;
